import { colourOf } from "../lib/colours.ts";

export interface ChipPlayer {
  readonly name: string;
  readonly colour: string;
  readonly alive?: boolean;
}

/** A player's colour, symbol and name: colour is never the only signal (§15.5). */
export function Swatch({ colour, big = false }: { colour: string; big?: boolean }) {
  const c = colourOf(colour);
  return (
    <span
      className={`swatch ${big ? "big" : ""}`}
      style={{ background: c.hex }}
      aria-hidden="true"
      title={c.label}
    >
      {c.symbol}
    </span>
  );
}

export function PlayerChip({
  player,
  big = false,
  suffix,
}: {
  player: ChipPlayer | undefined;
  big?: boolean;
  suffix?: string;
}) {
  if (!player) return <span className="chip muted">Someone</span>;
  const ghost = player.alive === false;
  return (
    <span className={`chip ${ghost ? "ghost" : ""}`}>
      <Swatch colour={player.colour} big={big} />
      <span className="name" style={big ? { fontSize: "1.4rem" } : undefined}>
        {player.name}
        {suffix ? <span className="faint"> {suffix}</span> : null}
      </span>
      {ghost ? <span className="sr-only">(Ghost)</span> : null}
    </span>
  );
}
